import { customers } from "../config/customers";

export const getHostname = () => {
  const override = process.env.REACT_APP_HOST_OVERRIDE?.trim();
  if (override) return override;
  return window.location.hostname;
};

export const getCustomerKey = () => {
  const host = getHostname();
  if (host.includes("svenfleshman")) return "kunde1";
  if (host.includes("kunde2")) return "kunde2";
  return "default";
};

export const getApiBase = () => {
  const key = getCustomerKey();
  return customers[key].api;
};

export const getWpBase = () => getApiBase();
